import { QuickTableReact } from './QuickTableReact';
import { AutoCompleteQuickTableViewMode } from '../../ViewModels/AutoCompleteQuickTableViewMode';
export class AutoCompleteQuickTable extends QuickTableReact {
    constructor(props) {
        super(props, AutoCompleteQuickTableViewMode);
    }
    render() {
        const { width } = this.props;
        const { x, y, heightOfContainer } = this.state;
        const style = { width, height: heightOfContainer, left: x, top: y };
        return super.render(style);
    }
}
AutoCompleteQuickTable.defaultProps = {
    isAttached: false
};
